// LinkedIn Banner Templates
const bannerTemplates = [

  { 
    id: 'creative-orange', 
    name: 'Creative Orange', 
    thumbnail: '/images/Creative Orange.png',
    template: {
      name: 'Creative Orange',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#FF9800',
            draggable: false,
          },
          {
            id: 'circle-1',
            type: 'circle',
            x: 350,
            y: 198,
            radius: 120,
            fill: '#FFFFFF',
            opacity: 0.2,
            draggable: false,
          },
          {
            id: 'design-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg',
            x: 250,
            y: 80,
            width: 180,
            height: 180,
            draggable: true,
            cornerRadius: 90,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 640,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'CREATIVE PROFESSIONAL',
            x: 950,
            y: 120,
            fontSize: 55,
            fontFamily: 'Montserrat',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Designer | Illustrator | Creative Director',
            x: 950,
            y: 200,
            fontSize: 28,
            fontFamily: 'Montserrat',
            fontWeight: '400',
            fill: '#FFFFFF',
            width: 600,
            draggable: true,
            lineHeight: 1,
            align: 'left'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#FF9800',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  { 
    id: 'minimal-white', 
    name: 'Minimal White', 
    thumbnail: '/images/Minimal White.jpeg',
    template: {
      name: 'Minimal White',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#FFFFFF',
            draggable: false,
          },
          {
            id: 'line-1',
            type: 'line',
            x: 800,
            y: 150,
            points: [0, 0, 750, 0],
            stroke: '#333333',
            strokeWidth: 2,
            draggable: false,
          },
          {
            id: 'minimal-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 160,
            draggable: true,
            cornerRadius: 8,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 512,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'JOHN DOE',
            x: 950,
            y: 110,
            fontSize: 50,
            fontFamily: 'Raleway',
            fontWeight: '700',
            fill: '#333333',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Minimalist | Clean Design Advocate | Professional',
            x: 950,
            y: 210,
            fontSize: 26,
            fontFamily: 'Raleway',
            fontWeight: '400',
            fill: '#555555',
            width: 600,
            draggable: true,
            lineHeight: 1,
            align: 'left'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#FFFFFF',
        zoom: 0.9,
        showGrid: false
      }
    }
  },

  { 
    id: 'corporate-gray', 
    name: 'Corporate Gray', 
    thumbnail: '/images/Corporate Gray.jpeg',
    template: {
      name: 'Corporate Gray',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#607D8B',
            draggable: false,
          },
          {
            id: 'rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 10,
            height: 396,
            fill: '#FF5722',
            draggable: false,
          },
          {
            id: 'corporate-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 160,
            draggable: true,
            cornerRadius: 8,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 512,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'CORPORATE LEADER',
            x: 950,
            y: 120,
            fontSize: 55,
            fontFamily: 'Open Sans',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Business Development | Strategy | Executive',
            x: 950,
            y: 200,
            fontSize: 28,
            fontFamily: 'Open Sans',
            fontWeight: '400',
            fill: '#FFFFFF',
            width: 600,
            draggable: true,
            lineHeight: 1,
            align: 'left'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#607D8B',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'professional-signature', 
    name: 'Professional Signature', 
    thumbnail: '/images/Professional Signature.jpeg',
    template: {
      name: 'Professional Signature',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'background-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#ffffff',
            draggable: false,
          },
          {
            id: 'signature-text-1',
            type: 'heading',
            text: 'Richard Sanchez',
            x: 1000,
            y: 180,
            fontSize: 60,
            fontFamily: 'Dancing Script',
            fontWeight: '400',
            fill: '#000000',
            draggable: true,
            align: 'left',
            width: 600
          },
          {
            id: 'job-title-text',
            type: 'paragraph',
            text: 'Graphic Designer',
            x: 1000,
            y: 260,
            fontSize: 24,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#000000',
            draggable: true,
            align: 'left',
            width: 600
          },
          {
            id: 'email-text',
            type: 'paragraph',
            text: 'Hello@reallygreatsite.com',
            x: 1000,
            y: 300,
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#000000',
            draggable: true,
            align: 'left',
            width: 600
          },
          {
            id: 'laptop-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/577560/pexels-photo-577560.jpeg',
            x: 250,
            y: 100,
            width: 300,
            height: 200,
            draggable: true,
            cornerRadius: 0,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 427,
            crossOrigin: 'anonymous'
          },
          {
            id: 'coffee-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/324028/pexels-photo-324028.jpeg',
            x: 580,
            y: 150,
            width: 150,
            height: 150,
            draggable: true,
            cornerRadius: 75,
            opacity: 1,
            originalWidth: 800,
            originalHeight: 800,
            crossOrigin: 'anonymous'
          },
          {
            id: 'plant-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/4751978/pexels-photo-4751978.jpeg',
            x: 650,
            y: 120,
            width: 120,
            height: 180,
            draggable: true,
            cornerRadius: 0,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 960,
            crossOrigin: 'anonymous'
          },
          {
            id: 'pencil-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/35202/pencil-paper-design-white.jpg',
            x: 250,
            y: 320,
            width: 200,
            height: 50,
            draggable: true,
            cornerRadius: 0,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 160,
            rotation: 15,
            crossOrigin: 'anonymous'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#ffffff',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'tech-gradient',
    name: 'Tech Gradient', 
    thumbnail: '/images/tech-gradient.jpg',
    template: {
      name: 'Tech Gradient',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            draggable: false,
          },
          {
            id: 'code-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg',
            x: 250,
            y: 50,
            width: 200,
            height: 160,
            draggable: true,
            cornerRadius: 8,
            opacity: 0.9,
            originalWidth: 640,
            originalHeight: 512,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'SOFTWARE ENGINEER',
            x: 800,
            y: 100,
            fontSize: 65,
            fontFamily: 'Inter',
            fontWeight: '800',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Full-Stack Developer | Cloud Architecture | DevOps',
            x: 800,
            y: 180,
            fontSize: 26,
            fontFamily: 'Inter',
            fontWeight: '400',
            fill: '#E0E7FF',
            width: 600,
            draggable: true,
            lineHeight: 1.2,
            align: 'left'
          },
          {
            id: 'accent-rect',
            type: 'rectangle',
            x: 800,
            y: 260,
            width: 80,
            height: 4,
            fill: '#60A5FA',
            draggable: true,
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'creative-pink',
    name: 'Creative Pink', 
    thumbnail: '/images/creative-pink.jpg',
    template: {
      name: 'Creative Pink',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#EC4899',
            draggable: false,
          },
          {
            id: 'circle-1',
            type: 'circle',
            x: 350,
            y: 100,
            radius: 100,
            fill: '#FFFFFF',
            opacity: 0.15,
            draggable: false,
          },
          {
            id: 'circle-2',
            type: 'circle',
            x: 300,
            y: 300,
            radius: 60,
            fill: '#FFFFFF',
            opacity: 0.1,
            draggable: false,
          },
          {
            id: 'creative-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg',
            x: 250,
            y: 80,
            width: 180,
            height: 180,
            draggable: true,
            cornerRadius: 90,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 640,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'CREATIVE DIRECTOR',
            x: 850,
            y: 120,
            fontSize: 58,
            fontFamily: 'Playfair Display',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Brand Strategy • Visual Design • Creative Leadership',
            x: 850,
            y: 200,
            fontSize: 24,
            fontFamily: 'Playfair Display',
            fontWeight: '400',
            fill: '#FECACA',
            width: 650,
            draggable: true,
            lineHeight: 1.3,
            align: 'left'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#EC4899',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'dark-professional',
    name: 'Dark Professional', 
    thumbnail: '/images/dark-professional.jpg',
    template: {
      name: 'Dark Professional',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#1F2937',
            draggable: false,
          },
          {
            id: 'accent-rect',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 8,
            fill: '#10B981',
            draggable: false,
          },
          {
            id: 'marketing-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 180,
            draggable: true,
            cornerRadius: 12,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 576,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'MARKETING STRATEGIST',
            x: 850,
            y: 110,
            fontSize: 52,
            fontFamily: 'Roboto',
            fontWeight: '700',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'Digital Marketing • Growth Hacking • Data Analytics',
            x: 850,
            y: 180,
            fontSize: 28,
            fontFamily: 'Roboto',
            fontWeight: '400',
            fill: '#9CA3AF',
            width: 700,
            draggable: true,
            lineHeight: 1.2,
            align: 'left'
          },
          {
            id: 'bottom-accent',
            type: 'rectangle',
            x: 0,
            y: 388,
            width: 1584,
            height: 8,
            fill: '#10B981',
            draggable: false,
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#1F2937',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'minimal-elegant',
    name: 'Minimal Elegant', 
    thumbnail: '/images/minimal-elegant.jpg',
    template: {
      name: 'Minimal Elegant',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-rect-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#F9FAFB',
            draggable: false,
          },
          {
            id: 'side-rect',
            type: 'rectangle',
            x: 1400,
            y: 0,
            width: 184,
            height: 396,
            fill: '#374151',
            draggable: false,
          },
          {
            id: 'elegant-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 160,
            draggable: true,
            cornerRadius: 8,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 512,
            crossOrigin: 'anonymous'
          },
          {
            id: 'heading-1',
            type: 'heading',
            text: 'SARAH JOHNSON',
            x: 800,
            y: 100,
            fontSize: 62,
            fontFamily: 'Lora',
            fontWeight: '700',
            fill: '#111827',
            draggable: true,
            align: 'left'
          },
          {
            id: 'paragraph-1',
            type: 'paragraph',
            text: 'UX/UI Designer',
            x: 800,
            y: 180,
            fontSize: 32,
            fontFamily: 'Lora',
            fontWeight: '400',
            fill: '#6B7280',
            width: 400,
            draggable: true,
            lineHeight: 1.2,
            align: 'left'
          },
          {
            id: 'divider-line',
            type: 'line',
            x: 800,
            y: 240,
            points: [0, 0, 120, 0],
            stroke: '#D1D5DB',
            strokeWidth: 2,
            draggable: true,
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#F9FAFB',
        zoom: 0.9,
        showGrid: false
      }
    }
  },

  {
    id: 'executive-authority',
    name: 'Executive Authority', 
    thumbnail: '/images/executive-authority.jpg',
    template: {
      name: 'Executive Authority',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-gradient',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#0F172A',
            draggable: false,
          },
          {
            id: 'accent-bar-top',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 6,
            fill: '#F59E0B',
            draggable: false,
          },
          {
            id: 'geometric-element-1',
            type: 'rectangle',
            x: 1200,
            y: 60,
            width: 280,
            height: 2,
            fill: '#334155',
            draggable: false,
          },
          {
            id: 'geometric-element-2',
            type: 'rectangle',
            x: 1250,
            y: 90,
            width: 230,
            height: 2,
            fill: '#475569',
            draggable: false,
          },
          {
            id: 'geometric-element-3',
            type: 'rectangle',
            x: 1300,
            y: 120,
            width: 180,
            height: 2,
            fill: '#64748B',
            draggable: false,
          },
          {
            id: 'executive-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184299/pexels-photo-3184299.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 180,
            draggable: true,
            cornerRadius: 12,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 576,
            crossOrigin: 'anonymous'
          },
          {
            id: 'name-heading',
            type: 'heading',
            text: 'ALEXANDRA MORGAN',
            x: 800,
            y: 65,
            fontSize: 52,
            fontFamily: 'Inter',
            fontWeight: '800',
            fill: '#FFFFFF',
            draggable: true,
            align: 'left'
          },
          {
            id: 'title-heading',
            type: 'heading',
            text: 'Chief Executive Officer',
            x: 800,
            y: 130,
            fontSize: 34,
            fontFamily: 'Inter',
            fontWeight: '400',
            fill: '#F59E0B',
            draggable: true,
            align: 'left'
          },
          {
            id: 'company-text',
            type: 'paragraph',
            text: 'Fortune 500 Technology Solutions',
            x: 800,
            y: 180,
            fontSize: 20,
            fontFamily: 'Inter',
            fontWeight: '300',
            fill: '#CBD5E1',
            width: 500,
            draggable: true,
            lineHeight: 1.4,
            align: 'left'
          },
          {
            id: 'expertise-text',
            type: 'paragraph',
            text: 'Strategic Leadership • Digital Transformation • Global Operations',
            x: 800,
            y: 220,
            fontSize: 18,
            fontFamily: 'Inter',
            fontWeight: '500',
            fill: '#94A3B8',
            width: 600,
            draggable: true,
            lineHeight: 1.5,
            align: 'left'
          },
          {
            id: 'achievement-highlight',
            type: 'rectangle',
            x: 800,
            y: 270,
            width: 4,
            height: 60,
            fill: '#F59E0B',
            draggable: false,
          },
          {
            id: 'achievement-text',
            type: 'paragraph',
            text: '25+ Years Experience\n$2B+ Revenue Generated\n50+ Markets Worldwide',
            x: 820,
            y: 275,
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: '600',
            fill: '#E2E8F0',
            width: 400,
            draggable: true,
            lineHeight: 1.6,
            align: 'left'
          },
          {
            id: 'accent-bar-bottom',
            type: 'rectangle',
            x: 0,
            y: 390,
            width: 1584,
            height: 6,
            fill: '#F59E0B',
            draggable: false,
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#0F172A',
        zoom: 0.9,
        showGrid: false
      }
    }
  },
  {
    id: 'creative-visionary',
    name: 'Creative Visionary', 
    thumbnail: '/images/creative-visionary.jpg',
    template: {
      name: 'Creative Visionary',
      pages: [{
        id: '1',
        name: 'Page 1',
        elements: [
          {
            id: 'bg-base',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 1584,
            height: 396,
            fill: '#FAFAFA',
            draggable: false,
          },
          {
            id: 'color-block-1',
            type: 'rectangle',
            x: 0,
            y: 0,
            width: 8,
            height: 396,
            fill: '#EC4899',
            draggable: false,
          },
          {
            id: 'color-block-2',
            type: 'rectangle',
            x: 8,
            y: 0,
            width: 8,
            height: 396,
            fill: '#8B5CF6',
            draggable: false,
          },
          {
            id: 'color-block-3',
            type: 'rectangle',
            x: 16,
            y: 0,
            width: 8,
            height: 396,
            fill: '#06B6D4',
            draggable: false,
          },
          {
            id: 'main-circle',
            type: 'circle',
            x: 1200,
            y: 200,
            radius: 140,
            fill: '#EC4899',
            opacity: 0.08,
            draggable: false,
          },
          {
            id: 'accent-circle-1',
            type: 'circle',
            x: 1350,
            y: 120,
            radius: 60,
            fill: '#8B5CF6',
            opacity: 0.12,
            draggable: false,
          },
          {
            id: 'accent-circle-2',
            type: 'circle',
            x: 1100,
            y: 80,
            radius: 30,
            fill: '#06B6D4',
            opacity: 0.15,
            draggable: false,
          },
          {
            id: 'visionary-image',
            type: 'image',
            src: 'https://images.pexels.com/photos/3184317/pexels-photo-3184317.jpeg',
            x: 250,
            y: 80,
            width: 200,
            height: 180,
            draggable: true,
            cornerRadius: 12,
            opacity: 1,
            originalWidth: 640,
            originalHeight: 576,
            crossOrigin: 'anonymous'
          },
          {
            id: 'name-heading',
            type: 'heading',
            text: 'JORDAN CHEN',
            x: 800,
            y: 55,
            fontSize: 56,
            fontFamily: 'Poppins',
            fontWeight: '700',
            fill: '#1F2937',
            draggable: true,
            align: 'left'
          },
          {
            id: 'creative-title',
            type: 'heading',
            text: 'Creative Director & Brand Strategist',
            x: 800,
            y: 125,
            fontSize: 28,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#EC4899',
            draggable: true,
            align: 'left'
          },
          {
            id: 'company-info',
            type: 'paragraph',
            text: 'Leading Innovation at Pixel & Purpose Studio',
            x: 800,
            y: 165,
            fontSize: 18,
            fontFamily: 'Poppins',
            fontWeight: '400',
            fill: '#6B7280',
            width: 500,
            draggable: true,
            lineHeight: 1.4,
            align: 'left'
          },
          {
            id: 'divider-line',
            type: 'rectangle',
            x: 800,
            y: 200,
            width: 80,
            height: 3,
            fill: '#EC4899',
            draggable: false,
          },
          {
            id: 'specialties',
            type: 'paragraph',
            text: 'Brand Identity • Digital Campaigns • Creative Strategy • Team Leadership',
            x: 800,
            y: 225,
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#374151',
            width: 700,
            draggable: true,
            lineHeight: 1.5,
            align: 'left'
          },
          {
            id: 'impact-stats',
            type: 'paragraph',
            text: '↗ 300% Brand Engagement Growth\n🏆 15+ Design Awards\n🌍 Global Campaigns for Fortune 100',
            x: 800,
            y: 270,
            fontSize: 14,
            fontFamily: 'Poppins',
            fontWeight: '500',
            fill: '#059669',
            width: 600,
            draggable: true,
            lineHeight: 1.8,
            align: 'left'
          },
          {
            id: 'contact-cta',
            type: 'paragraph',
            text: 'Let\'s create something extraordinary together →',
            x: 800,
            y: 340,
            fontSize: 16,
            fontFamily: 'Poppins',
            fontWeight: '600',
            fill: '#8B5CF6',
            width: 500,
            draggable: true,
            lineHeight: 1.2,
            align: 'left'
          }
        ]
      }],
      canvasSettings: {
        width: 1584,
        height: 396,
        background: '#FAFAFA',
        zoom: 0.9,
        showGrid: false
      }
    }
  }
];

export default bannerTemplates; 